<template>
    <ul class="selection-menu">
        <li>
            <button class="button" type="button" v-on:click="setActiveTab(TAB_NEAREST)" :class="{active: ACTIVE_TAB === TAB_NEAREST}">
              Nejbližší
            </button>
        </li>
        <li>
            <button class="button" type="button" v-on:click="setActiveTab(TAB_ALL)" :class="{active: ACTIVE_TAB === TAB_ALL}">
              Všichni
            </button>
        </li>
        <li>
            <button class="button" type="button" v-on:click="setActiveTab(TAB_SEARCH)" :class="{active: ACTIVE_TAB === TAB_SEARCH}">
              Hledání
            </button>
        </li>
    </ul>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import {TAB_NEAREST, TAB_ALL, TAB_SEARCH} from './constants';
    import {SET_ACTIVE_TAB} from './action';
    import {ACTIVE_TAB} from './getter';
    import {NAMESPACE} from './store';

    export default {
        name: 'ContactTabs',
        data: () => {
            return {TAB_NEAREST, TAB_ALL, TAB_SEARCH}
        },
        computed: {
            ...mapGetters(NAMESPACE, [ACTIVE_TAB])
        },
        methods: {
            ...mapActions(NAMESPACE, [SET_ACTIVE_TAB]),
            setActiveTab(tabName) {
                this[SET_ACTIVE_TAB](tabName);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/contact/Tabs.vue